module.exports = __webpack_public_path__ + "img/akusherstij-stacioner.0db6bead.jpg";